import React, { useEffect, useState } from 'react';
import HeaderModules from '../HeaderModules';
import { BarChartOutlined } from '@material-ui/icons';
import { Line } from 'react-chartjs-2';
import { fb } from '../../utils/Firebase';

export const StatisticsScreen = () => {

    const [ chartData, setChartData ] = useState({});

    useEffect(() => {
        let subscribed = true;
        subscribed && handleGetData();
        return () => subscribed = false;
    }, []);

    const handleGetData = async () => {
        const tempMount = [];
        const tempQuantity = [];
        const year = new Date().getFullYear();
        const response = await fb.firestore().collection('estadisticas').doc('liquidaciones').collection(String(year)).orderBy('mes', 'asc').get();
        
        response.forEach(doc => {
            tempMount.push(doc.id);
            tempQuantity.push(doc.data().cantidad);
        });

        setChartData({
            labels: tempMount,
            datasets:   [{
                label: '# de liquidaciones',
                data: tempQuantity,
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(255, 159, 64, 0.2)',
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(255, 159, 64, 0.2)'
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)',
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)'
                ],
                borderWidth: 2,
                lineTension: 0
            }]
        });
    }
   
    return (
        <>
            <HeaderModules 
                icon={<BarChartOutlined htmlColor='rgba(0,0,0, .7)' />} 
                title='Estadísticas' 
            />
            <div style={{ width: 500, background: '#fff', borderRadius: 4, marginTop: 10 }}>
                <Line data={ chartData } options= {{
                    responsive: true,
                    title: {
                        text: `Liquidaciones efectuadas año ${new Date().getFullYear()}`,
                        display: true
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }} />
            </div>
        </>
    );
}